import { defineComponent, computed } from "@vue/composition-api";
import { routeParamsBuilder } from "@/views/helpers";
import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "mGrid",
  setup(_props, ctx) {
    let $store = ctx.root.$store;

    const companyName = computed(() => {
      return $store.getters.companyName;
    });

    const userName = computed(() => {
      return $store.getters.userName;
    });

    const isLoggedIn = computed(() => {
      return $store.getters.isLoggedIn;
    });

    const workOrderMode = computed(() => {
      return $store.getters.workOrderMode;
    });

    const activeLink = (rtParams: { name: string }) => {
      return rtParams.name === ctx.root.$route.name;
    };

    let isFieldWorker = computed(() => {
      return $store.getters.isFieldWorker;
    });

    const routeParams = routeParamsBuilder();

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    const logOut = () => {
      const jsConn = new JSConn();
      $store.dispatch("logOutUser", jsConn).then(() => {
        ctx.root.$router.push(routeParams.mLogIn);
      });
    };

    return {
      activeLink,
      routeParams,
      companyName,
      userName,
      logOut,

      isLoggedIn,

      workOrderMode,
      workOrder,

      isFieldWorker,
    };
  },
});
